import { render, staticRenderFns } from "./ops_desk_public_form.vue?vue&type=template&id=cdb912f0&scoped=true&"
import script from "./ops_desk_public_form.vue?vue&type=script&lang=js&"
export * from "./ops_desk_public_form.vue?vue&type=script&lang=js&"
import style0 from "./ops_desk_public_form.vue?vue&type=style&index=0&id=cdb912f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb912f0",
  null
  
)

export default component.exports